import { AGALTokenizer } from '../aglsl/AGALTokenizer';
import { AGLSLParser } from '../aglsl/AGLSLParser';
import { Settings } from '../Settings';
var TEST_PLACE = /(#define|#version|precision).*\n/gi;
var ProgramWebGL = /** @class */ (function () {
    function ProgramWebGL(gl) {
        // private static _uniformLocationNameDictionary:Array<string> = ["fcarrr", "fs", "vcarrr"];
        this._id = ProgramWebGL.ProgramID++;
        this._uniforms = [{}, {}, {}];
        this._nameToIndex = {};
        this._attribs = [];
        this._uniformCache = new Array(16);
        this._gl = gl;
        this._program = this._gl.createProgram();
    }
    ProgramWebGL.prototype.upload = function (vertexProgram, fragmentProgram) {
        //detect whether highp can be used
        var vertexPrecision = this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT).precision;
        var fragmentPrecision = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT).precision;
        var vertexString = ProgramWebGL._aglslParser.parse(ProgramWebGL._tokenizer.decribeAGALByteArray(vertexProgram), vertexPrecision ? 'highp' : 'mediump');
        var fragmentString = ProgramWebGL._aglslParser.parse(ProgramWebGL._tokenizer.decribeAGALByteArray(fragmentProgram), fragmentPrecision ? 'highp' : 'mediump');
        if (!this.name) {
            this.name = 'PROG_AGAL_' + this._id;
        }
        this.uploadRaw(vertexString, fragmentString);
    };
    ProgramWebGL.prototype.uploadRaw = function (vertexGLSL, fragmentGLSL) {
        if (!this.name) {
            this.name = 'PROG_GLSL_' + this._id;
        }
        vertexGLSL = this.insertName(vertexGLSL);
        fragmentGLSL = this.insertName(fragmentGLSL);
        this._vertexShader = this._gl.createShader(this._gl.VERTEX_SHADER);
        this._fragmentShader = this._gl.createShader(this._gl.FRAGMENT_SHADER);
        this._gl.shaderSource(this._vertexShader, vertexGLSL);
        this._gl.compileShader(this._vertexShader);
        if (!this._gl.getShaderParameter(this._vertexShader, this._gl.COMPILE_STATUS))
            throw new Error(this._gl.getShaderInfoLog(this._vertexShader));
        this._gl.shaderSource(this._fragmentShader, fragmentGLSL);
        this._gl.compileShader(this._fragmentShader);
        if (!this._gl.getShaderParameter(this._fragmentShader, this._gl.COMPILE_STATUS))
            throw new Error(this._gl.getShaderInfoLog(this._fragmentShader));
        this._gl.attachShader(this._program, this._vertexShader);
        this._gl.attachShader(this._program, this._fragmentShader);
        this._gl.linkProgram(this._program);
        if (!this._gl.getProgramParameter(this._program, this._gl.LINK_STATUS))
            throw new Error(this._gl.getProgramInfoLog(this._program));
        this.reset();
    };
    ProgramWebGL.prototype.insertName = function (shader) {
        var mathes = shader.match(TEST_PLACE) || [];
        var last = mathes[mathes.length - 1];
        var corret = last ? shader.lastIndexOf(last) + last.length : 0;
        return shader.substr(0, corret)
            + ("\n#define SHADER_NAME " + this.name + "\n\n")
            + shader.substr(corret);
    };
    ProgramWebGL.prototype.reset = function () {
        this._uniforms[0] = {};
        this._uniforms[1] = {};
        this._uniforms[2] = {};
        this._attribs.length = 0;
        this._uniformCache.fill('');
    };
    ProgramWebGL.prototype.getUniformLocation = function (programType, indexOrName) {
        if (indexOrName === void 0) { indexOrName = -1; }
        var isIndex = typeof indexOrName === 'number';
        var index = isIndex ? indexOrName : this._nameToIndex[indexOrName];
        if (typeof index !== 'undefined' && this._uniforms[programType][index + 1] != null) {
            return this._uniforms[programType][index + 1];
        }
        var name = isIndex
            ? ProgramWebGL._getAGALUniformName(programType, indexOrName)
            : indexOrName;
        this._nameToIndex[name] = index + 1;
        return (this._uniforms[programType][index + 1] = this._gl.getUniformLocation(this._program, name));
    };
    ProgramWebGL._getAGALUniformName = function (type, index) {
        if (index === void 0) { index = -1; }
        return (index === -1)
            ? this._uniformLocationNameDictionary[type]
            : this._uniformLocationNameDictionary[type] + index;
    };
    ProgramWebGL.prototype._needCache = function (index, value) {
        var cached = this._uniformCache[index];
        var hash = value instanceof Float32Array
            ? new Uint32Array(value.buffer).join('')
            : '' + value;
        // already uploaded
        return (cached && hash === cached) ? void 0 : hash;
    };
    ProgramWebGL.prototype.uniform1i = function (type, index, value) {
        var location = this.getUniformLocation(type, index);
        if (Settings.ENABLE_UNIFORM_CACHE) {
            var hash = this._needCache(type * 4 + index + 1, value);
            // return undef hash if not require to uppload;
            if (hash === void 0) {
                return;
            }
            this._uniformCache[type * 4 + index + 1] = hash;
        }
        this._gl.uniform1i(location, value);
    };
    ProgramWebGL.prototype.uniform4fv = function (type, value) {
        var location = this.getUniformLocation(type);
        if (Settings.ENABLE_UNIFORM_CACHE) {
            var hash = this._needCache(type * 4, value);
            // return undef hash if not require to uppload;
            if (hash === void 0) {
                return;
            }
            this._uniformCache[type * 4] = hash;
        }
        this._gl.uniform4fv(location, value);
    };
    ProgramWebGL.prototype.getAttribLocation = function (index) {
        if (this._attribs[index] != null)
            return this._attribs[index];
        return (this._attribs[index] = this._gl.getAttribLocation(this._program, 'va' + index));
    };
    ProgramWebGL.prototype.dispose = function () {
        this._gl.deleteProgram(this._program);
    };
    ProgramWebGL.prototype.focusProgram = function () {
        this._uniformCache.fill('');
        this._gl.useProgram(this._program);
    };
    Object.defineProperty(ProgramWebGL.prototype, "glProgram", {
        get: function () {
            return this._program;
        },
        enumerable: true,
        configurable: true
    });
    ProgramWebGL.ProgramID = 0;
    ProgramWebGL._tokenizer = new AGALTokenizer();
    ProgramWebGL._aglslParser = new AGLSLParser();
    ProgramWebGL._uniformLocationNameDictionary = ['fc', 'fs', 'vc'];
    return ProgramWebGL;
}());
export { ProgramWebGL };
